import React, { useEffect, useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  MENU_SIDEBAR_KEYS,
  ACCOUNT_KEYS,
  LOAN_KEYS,
  DEPOSITS_KEYS,
  DIALOG_KEYS,
  SIDENAV_KEYS,
} from '../../utils/translation-constants'
import DepositsService from '../../services/deposits.service'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import Loading from 'custom/assets/loaders/Loading'
import NumberFormat from 'react-number-format'
import AddIcon from 'custom/assets/common-icons/Add.svg'
import Pagination from 'react-js-pagination'
import { getMenuListSelector } from '../../selectors'
import { useSelector } from 'react-redux'

export default function Deposits() {
  const { t } = useTranslation()
  const history = useHistory()
  const [stage, setStage] = useState(0)
  const [depositsList, setDepositsList] = useState([])
  const [depositDetails, setDepositDetails] = useState([])
  const [depositStatementDetails, setDepositStatementDetails] = useState([])
  const [loading, setLoading] = useState(false)
  const [detailsLoader, setDetailsLoader] = useState(false)
  const [noRecords, setNoRecords] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const pageLimit = 5
  const [slicedDetailStatementList, setSlicedDetailStatementList] = useState([])
  const [expanded, setExpanded] = useState(null)
  const [tabIndex, setTabIndex] = useState(1)
  const [expandedStatement, setExpandedStatement] = useState(null)
  const menuConfig = useSelector(getMenuListSelector)['DEPOSIT'] || {}

  const getDepositAccountDetails = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        const reqParams = {
          accountNo: selected.accountNo,
          brnCode: selected.brnCode,
        }
        const response = await DepositsService.getDepositAccountDetails(reqParams)
        if (response.status === 200) {
          setDepositDetails(response.data)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [depositsList],
  )

  const getDepositAccountStatementDetails = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        const reqParams = {
          srcAccount: selected.accountNo,
          brnCode: selected.brnCode,
        }
        const response = await DepositsService.getDepositAccountStatement(reqParams)
        if (response.status === 200) {
          setDepositStatementDetails(response.data['depositEntriesList'])
          sliceDetailedStatement(1, response.data['depositEntriesList'])
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [depositsList],
  )

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderList()
      default:
        return renderList()
    }
  }

  useEffect(() => {
    getAllDepositAccounts()
  }, [])

  const getAllDepositAccounts = useCallback(async () => {
    try {
      setLoading(true)
      const response = await DepositsService.getTermDepositAccounts()
      if (response.status === 200) {
        response.data['accountSummaryDetails'].forEach((element) => {
          element.isActive = false
        })
        setDepositsList(response.data['accountSummaryDetails'])
        //sliceDetailedStatement(1, response.data['accountSummaryDetails'])
        setStage(1)
        setNoRecords(response.data['accountSummaryDetails'].length > 0 ? false : true)
      }
    } catch (err) {}
  }, [])

  const sliceDetailedStatement = useCallback(async (currentPageNo, lst) => {
    // useEffect (  () => {
    setCurrentPage(currentPageNo)
    let start = (currentPageNo - 1) * pageLimit
    let end = currentPageNo * pageLimit
    if (lst && lst.length > 0) {
      let x = lst.slice(start, end < lst.length ? end : lst.length)
      setSlicedDetailStatementList(x)
      setExpandedStatement(null)
    } else {
    }
  }, []) //currentPage

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderView() {
    return (
      <>
        {!loading && (
          <div className='row'>
            <div className='col-4'>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.ACCOUNT_DESCRIPTION)}</label>
              <p>{depositDetails?.accDesc || '-'}</p>
              <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.ACCOUNTNO_1)}</label>
              <p>{depositDetails?.accountNo || '-'}</p>
              <label>{t(ACCOUNT_KEYS.DETAILS_KEYS.ACCOUNT_OPENING_DATE)}</label>
              <p>{depositDetails?.accountOpenDate || '-'}</p>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.maturityDate)}</label>
              <p>{depositDetails?.maturityDate || '-'}</p>
              <label>{t(DEPOSITS_KEYS.TERM_DEPOSITS_DETAILS_KEYS.TD_AMOUNT)}</label>
              <p>{depositDetails?.tdAmt || '-'}</p>
            </div>

            <div className='col-4'>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.brnCode)}</label>
              <p>{depositDetails?.brnCode || '-'}</p>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.currency)}</label>
              <p>{depositDetails?.currency || '-'}</p>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.CUSTOMER_ID)}</label>
              <p>{depositDetails?.customerId || '-'}</p>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.PROD_CATEGORY)}</label>
              <p>{depositDetails?.prodCategory || '-'}</p>
            </div>

            <div className='col-4'>
              <label>{t(DEPOSITS_KEYS.TERM_DEPOSITS_DETAILS_KEYS.DEBIT)}</label>
              <p>{depositDetails?.debitAccBrn || '-'}</p>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.INTEREST_RATE)}</label>
              <p>{depositDetails?.interestRate || '-'}</p>
              <label>{t(DEPOSITS_KEYS.TERM_DEPOSITS_DETAILS_KEYS.MATURITY_AMOUNT)}</label>
              <p>
                <NumberFormat
                  value={depositDetails?.maturityAmt || '-'}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  className='ml-0'
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </p>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.status)}</label>
              <p>{depositDetails?.status || '-'}</p>
            </div>
          </div>
        )}
      </>
    )
  }

  function renderStatement() {
    return (
      <>
        {depositStatementDetails.length === 0 && (
          <div className='no-data-found'>{t(DIALOG_KEYS.NO_STATEMENT)}</div>
        )}
        {depositStatementDetails.map((option, index) => (
          <div key={index} className='loan-card' style={{ backgroundColor: '#fff' }}>
            <div
              className='loan-header'
              onClick={async () => {
                if (expandedStatement == index) {
                  setExpandedStatement(null)
                } else {
                  setExpandedStatement(index)
                }
              }}>
              <span>
                {' '}
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REF)} : {option.refNo}
              </span>
              <span>
                {' '}
                <NumberFormat
                  value={option?.amount || '-'}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </span>
            </div>

            {expandedStatement === index && (
              <div className='row loan-details '>
                <div className='col-4'>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.ACCOUNTNO_1)}</label>
                  <span>{option?.accNo || '-'}</span>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REFERENCE_NUMBER)}</label>
                  <span>{option?.refNo || '-'}</span>
                </div>
                <div className='col-4'>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.AMOUNT)}</label>
                  <span>
                    <NumberFormat
                      value={option?.amount || '-'}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={''}
                      fixedDecimalScale={true}
                      decimalScale={2}
                      allowEmptyFormatting
                    />
                  </span>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.SERIAL)}</label>
                  <span>{option?.slNumber || '-'}</span>
                </div>
                <div className='col-4'>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.TRANS_DATE)}</label>
                  <span>{option?.transactionDate || '-'}</span>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.NARRATION)}</label>
                  <span>{option?.narration || '-'}</span>
                </div>
              </div>
            )}
          </div>
        ))}
        {depositStatementDetails.length > 0 && depositStatementDetails.length > 5 ? (
          <div className='d-flex justify-content-center mb-5 mt-2'>
            {loading ? null : (
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={5}
                totalItemsCount={depositStatementDetails.length}
                pageRangeDisplayed={5}
                itemClass='page-item'
                linkClass='page-link'
                onChange={(page) => sliceDetailedStatement(page, depositStatementDetails)}
              />
            )}
          </div>
        ) : null}
      </>
    )
  }

  function renderList() {
    return (
      <>
        {noRecords && <div className='no-data-found'>{t(DIALOG_KEYS.NO_DEPOSITS)} </div>}

        {depositsList.map((option, index) => (
          <div key={index} className='deposit-menu-card'>
            <div
              className='deposit-header'
              onClick={async () => {
                if (expanded == index) {
                  setExpanded(null)
                  setExpandedStatement(null)
                } else {
                  setTabIndex(1)
                  setExpanded(index)
                  setExpandedStatement(null)
                  await getDepositAccountDetails(option)
                  await getDepositAccountStatementDetails(option)
                }
              }}>
              <div>
                <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.ACCOUNTNO_1)}</label>
                <p>{option?.accountNo}</p>
              </div>
              <div>
                <label>{t(DEPOSITS_KEYS.SELECT_TYPE_KEYS.DEPOSITE)}</label>
                <p>
                  {option?.currency+' '}
                  <NumberFormat
                    value={option?.avlBal}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </p>
              </div>
            </div>

            {expanded === index && (
              <div className='loan-details'>
                <div className='row tab-navbar tab-navbar1'>
                  <div className={tabIndex === 1 ? 'col-4 selected' : 'col-4'}>
                    <span
                      onClick={() => {
                        setTabIndex(1)
                        setExpandedStatement(null)
                      }}>
                      {t(DEPOSITS_KEYS.SELECT_TYPE_KEYS.VIEW)}
                    </span>
                  </div>
                  <div className={tabIndex === 2 ? 'col-4 selected' : 'col-4'}>
                    <span
                      onClick={() => {
                        setTabIndex(2)
                      }}>
                      {t(DEPOSITS_KEYS.SELECT_TYPE_KEYS.STATEMENT)}
                    </span>
                  </div>
                </div>
                {loading && renderLoading()}
                {tabIndex === 1 && !loading && renderView()}
                {tabIndex === 2 && !loading && renderStatement()}
              </div>
            )}
          </div>
        ))}
      </>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='DEPOSIT' showEmptySpace={true} keyPath={'DEPOSIT'}>
      <div className='row'>
        <div className='col-7 d-flex'>
          <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.DEPOSITS)}</div>
        </div>
        {menuConfig['CREATE_TERM_DEPOSIT'] && (
          <div className='col-5 text-right'>
            <button
              onClick={() => history.push('/deposits/create-term-deposits')}
              type='button'
              className='btn p-2 detailed-statement-btn'>
              <img width={25} height={25} src={AddIcon} />
              <span style={{ marginLeft: 10 }} className='font-weight-600'>
                {t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SUBTITLE_6)}
              </span>
            </button>
          </div>
        )}
      </div>

      {renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
